import React from "react";
import { Typography, Button, CircularProgress } from "@material-ui/core";
import PlayArrowIcon from "@material-ui/icons/PlayArrow";
import { useCommissionContext } from "../../../../../contexts/CommissionContext";

/**
 *
 */
export default function PostProcessingTab() {
  const { postImportRunning, postImportStatus, handleRunPostImport } =
    useCommissionContext();

  return (
    <>
      <Typography variant="h6" gutterBottom>
        Post-Processing Scripts
      </Typography>
      <Typography variant="body2" color="textSecondary" paragraph>
        Run post-import scripts to update database after importing commission
        data.
      </Typography>

      {!postImportRunning ? (
        <Button
          variant="contained"
          color="primary"
          fullWidth
          onClick={handleRunPostImport}
          startIcon={<PlayArrowIcon />}
        >
          Run Post Import Script
        </Button>
      ) : (
        <div>
          <Button
            variant="contained"
            color="primary"
            disabled
            fullWidth
            startIcon={<CircularProgress size={20} />}
          >
            Running Post Import
          </Button>
          <Typography
            variant="body2"
            color="textSecondary"
            style={{ marginTop: 8 }}
          >
            Status: {postImportStatus}
          </Typography>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              margin: "10px 0",
            }}
          >
            <CircularProgress size={24} />
          </div>
        </div>
      )}
    </>
  );
}
